import React from "react";
import { type WeddingLanguage, weddingContent } from "./content";

interface WeddingDetailsProps {
  language: WeddingLanguage;
}

export function WeddingDetails({ language }: WeddingDetailsProps) {
  const content = weddingContent[language].details;

  return (
    <section id="details" className="wedding-section wedding-section--beige">
      <div className="wedding-container">
        <div className="details-grid">
          <div className="details-card">
            <div className="details-card__symbol">✦</div>
            <h3 className="details-card__title">{content.ceremony}</h3>
            <div className="details-card__stack">
              <div>
                <p className="details-card__label">{content.dateTime}</p>
                <p className="details-card__value">{content.detailsSoon}</p>
              </div>
              <div>
                <p className="details-card__label">{content.location}</p>
                <div className="details-card__value">
                  <div className="details-card__address">{content.ceremonyVenue}</div>
                </div>
              </div>
            </div>
            <a
              className="details-card__link"
              href={content.directionsUrl}
              target="_blank"
              rel="noreferrer"
            >
              {content.directionsSoon}
            </a>
          </div>

          <div className="details-card">
            <div className="details-card__symbol">❖</div>
            <h3 className="details-card__title">{content.reception}</h3>
            <div className="details-card__stack">
              <div>
                <p className="details-card__label">{content.dateTime}</p>
                <p className="details-card__value">{content.detailsSoon}</p>
              </div>
              <div>
                <p className="details-card__label">{content.location}</p>
                <div className="details-card__value">
                  <div className="details-card__address">{content.receptionVenue}</div>
                </div>
              </div>
              <p className="details-card__note">{content.receptionNote}</p>
            </div>
            <a
              className="details-card__link"
              href={content.directionsUrl}
              target="_blank"
              rel="noreferrer"
            >
              {content.directionsSoon}
            </a>
          </div>
        </div>

        <div className="dress-code">
          <div className="dress-code__icon" aria-hidden="true">
            <svg viewBox="0 0 64 64" className="dress-code__iconSvg">
              <path
                d="M22.5 18.5c3.8 0 7.6 1.5 10.5 4.4 2.9-2.9 6.7-4.4 10.5-4.4 2.7 0 5.4.8 7.7 2.4l1.8 1.2-1.1 1.9c-2.3 4-5.3 7.1-8.8 9.3 3.4 2.2 6.4 5.3 8.8 9.3l1.1 1.9-1.8 1.2c-2.3 1.6-5 2.4-7.7 2.4-3.8 0-7.6-1.5-10.5-4.4-2.9 2.9-6.7 4.4-10.5 4.4-2.7 0-5.4-.8-7.7-2.4L13 44.5l1.1-1.9c2.3-4 5.3-7.1 8.8-9.3-3.4-2.2-6.4-5.3-8.8-9.3l-1.1-1.9 1.8-1.2c2.3-1.6 5-2.4 7.7-2.4zm4.8 7.4-8.3 5.7 8.3 5.7c2.1-1.4 3.7-3.3 4.7-5.7-1-2.4-2.6-4.3-4.7-5.7zm11.4 0c-2.1 1.4-3.7 3.3-4.7 5.7 1 2.4 2.6 4.3 4.7 5.7l8.3-5.7-8.3-5.7zm-5.7 1.8c-1.8 0-3.3 1.5-3.3 3.3s1.5 3.3 3.3 3.3 3.3-1.5 3.3-3.3-1.5-3.3-3.3-3.3z"
                fill="currentColor"
              />
            </svg>
          </div>
          <h3 className="dress-code__title">{content.dressCode}</h3>
          <p className="dress-code__accent">{content.dressCodeAccent}</p>
          <p className="dress-code__text">{content.dressCodeText}</p>
        </div>
      </div>
    </section>
  );
}
